var _objectSpread = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

/**
 * Module containing functions about Factom server identities.
 * @module server
 */
var efficiency = require('./efficiency');

var coinbaseAddress = require('./coinbase-address');

var coinbaseCancel = require('./coinbase-cancel');

var _require = require('./factom-server-identity-manager'),
    FactomServerIdentityManager = _require.FactomServerIdentityManager;

module.exports = _objectSpread({
  FactomServerIdentityManager: FactomServerIdentityManager
}, require('./validation'), {
  generateEfficiencyUpdateEntry: efficiency.generateUpdateEntry,
  generateCoinbaseAddressUpdateEntry: coinbaseAddress.generateUpdateEntry,
  generateCoinbaseCancelEntry: coinbaseCancel.generateCoinbaseCancelEntry
});